import type { IconType } from "react-icons";
import { FiTrash2 } from "react-icons/fi";
import SafeIcon from "./SafeIcon";
import type { ConverterTheme } from "./types";

interface FileListItemProps {
  file: File;
  onRemove: (() => void) | null;
  icon: IconType;
  getFileExtension: (filename: string) => string;
  formatBytes: (bytes: number) => string;
  badgeClassForExt: (ext: string) => string;
  theme: ConverterTheme;
}

const FileListItem = ({
  file,
  onRemove,
  icon,
  getFileExtension,
  formatBytes,
  badgeClassForExt,
  theme,
}: FileListItemProps) => {
  const ext = getFileExtension(file.name) || "file";
  const badgeClass = badgeClassForExt(ext);

  return (
    <div
      className={`flex items-center justify-between rounded-xl border border-slate-100 bg-white/50 p-3 transition-colors dark:border-slate-700 dark:bg-slate-800/50 ${theme.queueHoverBorder}`}
    >
      <div className="flex min-w-0 items-center gap-3">
        <div
          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${theme.queueIcon}`}
        >
          <SafeIcon icon={icon} />
        </div>
        <div className="min-w-0">
          <p
            className="truncate text-sm font-semibold text-slate-800 dark:text-slate-100"
            title={file.name}
          >
            {file.name}
          </p>
          <div className="mt-0.5 flex items-center gap-2">
            <span
              className={`rounded px-1.5 py-0.5 text-[10px] font-bold uppercase ${badgeClass}`}
            >
              {ext}
            </span>
            <span className="text-[10px] text-slate-400">
              {formatBytes(file.size)}
            </span>
          </div>
        </div>
      </div>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={`Remove ${file.name}`}
          className="ml-2 shrink-0 rounded-lg p-2 text-slate-400 transition-colors hover:bg-red-50 hover:text-red-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 dark:hover:bg-red-900/20"
        >
          <SafeIcon icon={FiTrash2} />
        </button>
      )}
    </div>
  );
};

export default FileListItem;
